import { API_BASE } from '../../../api';

export const ENDPOINTS = {
    colores: `${API_BASE}/Colores`,
    coloresDefault: `${API_BASE}/Colores/default`,
    colorById: (id) => `${API_BASE}/Colores/${id}`,
    catColores: `${API_BASE}/CatColores`,
    catColorById: (id) => `${API_BASE}/CatColores/${id}`,
    catCategorias: `${API_BASE}/CatCategorias`,
    catCategoriaById: (id) => `${API_BASE}/CatCategorias/${id}`,
    logos: `${API_BASE}/Logos`,
    logosDefault: `${API_BASE}/Logos/default`,
    logoById: (id) => `${API_BASE}/Logos/${id}`,
    tipoLogos: `${API_BASE}/TipoLogos`,
    tipoLogoById: (id) => `${API_BASE}/TipoLogos/${id}`,
    imagenesSistema: `${API_BASE}/ImagenesSistema`,
    imagenesSistemaDefault: `${API_BASE}/ImagenesSistema/default`,
    imagenSistemaById: (id) => `${API_BASE}/ImagenesSistema/${id}`,
    tipoImagen: `${API_BASE}/TipoImagen`,
    tipoImagenById: (id) => `${API_BASE}/TipoImagen/${id}`,
    configuracionesSistema: `${API_BASE}/ConfiguracionesSistema`,
    configuracionSistemaById: (id) => `${API_BASE}/ConfiguracionesSistema/${id}`,
    configuracionTimeout: (userId) => `${API_BASE}/ConfiguracionesSistema/timeout/${userId}`,
};
